import {gql} from "@apollo/client";

export const SELECT_SPECIALITIES_WITH_ELECTIVE_COURSES_BY_PERSON_ID = gql`
   query getSpecialitiesByPersonId($person_id: Int!, $year_semester_id: Int!, $elective_summer_semester: Boolean!) {
      grid_elective_choice(where: {person_id: {_eq: $person_id}}) {
        course_id
        speciality_id
        decision
        elective_group
        course {
          id
          name
          elective_group
          course_group {
            id
            name
            full_name
          }
          course_type {
            id
            name
            full_name
          }
          method_of_conducting {
            id
            name
            full_name
          }
          course_semesters {
            id
            number
            hours
            ects
            form_of_passing {
              id
              name
              full_name
            }
          }
        }  
      }      
      study_person_speciality(where: {person_id: {_eq: $person_id}, year_semester_id: {_eq: $year_semester_id}}) {
        semester {
          id
          name
        }
        year_semester {
          id
          name
          current
        }
        speciality {
          id
          name
          instrument {
            id
            name
          }
          study {
            id
            name
            level
            form
            study_units {
              unit {
                id
                name
              }
            }
          }
          course_specialities(where: {course: {elective_summer_semester: {_eq: $elective_summer_semester}, course_group: {name: {_eq: "PDW"}}}}) {
            first_year_id
            last_year_id
            course {
              id
              name
              elective_group
              course_group {
                id
                name
                full_name
              }
              course_type {
                id
                name
                full_name
              }
              method_of_conducting {
                id
                name
                full_name
              }
              course_semesters {
                id
                number
                hours
                ects
                form_of_passing {
                  id
                  name
                  full_name
                }
              }
            }
          }
        }
      }
}`